<template>
  <div class="DataUpdate">
    <modal
      name="UpdateModal"
      width="900"
      height="auto"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
    >
    <div class="modalContainer userAdminModal">
    <div class="tabs">
    <a
      @click="activetab = 1; areatab = false"
      :class="{ active: activetab === 1 }"
    >
    Datos Básicos
    </a>

    <a
      @click="loadRoles"
      :class="{ active: activetab === 2 }"
    >
    Roles y Permisos
    </a>

    <a
      @click="loadAreas"
      :class="{ active: activetab === 3 }"
    >
    Área
    </a>

    </div>
    <div class="modalBody">
    <div v-if="activetab === 1" class="tabcontent">
      <ValidationObserver ref="obsFieldsUpdate">
        <FormUpdateClient
          :FieldsForm="formUpdate"
          :ModelForm="formUpdModel"
          :method="executeProcess"
          v-if="renderComponent2"
        />
      </ValidationObserver>
    </div>
    <div v-if="activetab === 2" class="tabcontent rolcontent">
    <h3 class="sectionLabel">Listado de Roles Ibero</h3>
    <div class="DataRoluser">
      <div
        v-for="itemRolList of listRol"
        v-show="itemRolList.idRole != 1"
        :key="itemRolList.idRole"
        class="status"
      >
        <div class="custom-control custom-checkbox">
          <input
            type="checkbox"
            v-model="modelRol[itemRolList.idRole]"
            :id="itemRolList.idRole"
            class="custom-control-input"
          />
          <label
            class="custom-control-label"
            :for="itemRolList.idRole"
          >
          {{itemRolList.namRole}}
          </label>
        </div>
      </div>
    </div>
    <h3 class="sectionLabel">Estado usuario</h3>
    <div class="DataRoluser">
      <div class="custom-control custom-checkbox">
        <input
          type="checkbox"
          v-model="formUpdModel.IdStatus"
          :id="'Sta_' + formUpdModel.IdPerson"
          class="custom-control-input"
        />
        <label
          class="custom-control-label"
          :for="'Sta_' + formUpdModel.IdPerson"
        >
        Activo
        </label>
      </div>
    </div>
    </div>
    <div v-if="activetab === 3" class="tabcontent areacontent">
    <h3 class="sectionLabel">Listado de Áreas por Rol</h3>
    <div class="DataAreauser" v-if="infoArea">
    <div v-for="(item,i) in listArea" :key="i">
    <h6 v-if="item.Areas">{{item.NamRole}}</h6>
    <div
      v-for="itemAreaList of item.Areas"
      :key="itemAreaList.IdArea"
      class="custom-control custom-checkbox"
    >
      <input
        type="checkbox"
        v-model="modelArea[itemAreaList.IdArea + '_' + item.IdRole]"
        :id="itemAreaList.IdArea + '_' + item.IdRole"
        class="custom-control-input"
      />
      <label
        class="custom-control-label"
        :for="itemAreaList.IdArea + '_' + item.IdRole"
      >
      {{itemAreaList.NamArea}}
      </label>
    </div>
    </div>
    </div>
    </div>
    </div>
    <div class="modalActions">
      <button
        v-if="$session.get('IberoJWTAdminLogin').idPerson != formUpdModel.IdPerson && areatab === false"
        id="UpdateUser"
        @click="UpdateUser"
        class="loginbtn primaryBtn"
      >
      Actualizar
      </button>

      <button
        v-else-if="activetab === 2 && areatab === false"
        id="UpdateUser"
        @click="UpdateUser"
        class="loginbtn primaryBtn"
      >
      Actualizar
      </button>

      <button
        v-else-if="activetab === 3 && areatab === true"
        id="UpdateUserArea"
        @click="UpdateUserArea"
        class="loginbtn primaryBtn"
      >
      Actualizar Área
      </button>

      <button
        id="CancelUser"
        @click="CancelUser"
        class="loginbtn secondaryBtn"
      >
      Cancelar
      </button>
    </div>
    </div>
    </modal>
    <div class="titlePage">Administracion - Usuarios Ibero</div>
    <va-notification
      color="info"
      v-if="addRExito"
      class="refNoData"
    >Se actualizo correctamente el usuario solicitado.</va-notification>
    <va-notification
      color="danger"
      v-if="refNoUpdate"
      class="refNoData"
    >La actualizacion del usuario presento un fallo.</va-notification>
    <va-notification
      color="danger"
      v-if="refWSUpdate"
      class="refNoData"
    >El servicio que ejecuta la actualización no se encuentra activo.</va-notification>

    <ValidationObserver ref="obsFieldsSearch">
      <FormSearchClient
        :FieldsForm="formSearch"
        :ModelForm="formSchModel"
        :method="executeProcess"
      />
    </ValidationObserver>
    <va-notification
      color="danger"
      id="refNoData"
      class="refNoData noShow"
    >No se encontró información del usuario solicitado.</va-notification>
    <div class="listClients">
      <DataTablePersons
        :InfoView="this.DLPersons"
        :HeadTable="this.HDPersons"
        :method="processData"
        v-if="renderComponent1"
      />
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-duplicates
import FormSearchClient from '@/components/forms/Forms.vue'
// eslint-disable-next-line import/no-duplicates
import FormUpdateClient from '@/components/forms/Forms.vue'
import IberoHelpers from '@/store/helpers.js'
import DataTablePersons from '@/components/data-tables/DataPersonsUpdate.vue'
import FormAddress from '@/components/Forms.vue'

export default {
  name: 'DataUpdate',
  components: {
    DataTablePersons,
    FormSearchClient,
    FormUpdateClient,
    FormAddress,
  },
  data () {
    return {
      infoArea: false,
      listRol: [],
      modelRol: {},
      listArea: [],
      modelArea: {},
      addRol: [],
      updateRol: [],
      addArea: [],
      updateArea: [],
      activetab: 1,
      areatab: false,
      formSchModel: {
        idTypeIdent: '',
        numIdentify: '',
        IdBannerNum: '',
      },
      formSearch: [
        {
          id: 'Sch_Document',
          model: 'numIdentify',
          name: 'Documento de Identidad',
          type: 'input',
          placeholder: 'Documento de Identidad',
          values: '',
          validate: {
            required: false,
            min: 7,
            max: 15,
            numeric: true,
            alpha_num: false,
          },
          class: 'col-md-3',
        },
        {
          id: 'Sch_IdBanner',
          model: 'IdBannerNum',
          name: 'Id Banner',
          type: 'input',
          placeholder: 'Id Banner',
          values: '',
          validate: {
            required: false,
            numeric: true,
          },
          class: 'col-md-3',
        },
        {
          id: 'Sch_Button',
          type: 'button',
          placeholder: 'Consultar',
          class: 'col-md-3',
        },
      ],
      formUpdModel: {
        idUpdatedBy: this.$session.get('IberoJWTAdminLogin').idPerson,
        IdPerson: '',
        IdStatus: '',
        IdUsrName: '',
        IdDocType: '',
        IdDocTypeName: '',
        IdDocument: '',
        IdBanner: '',
        IdNombre: '',
        IdApellidos: '',
        IdAddress: '',
        IdMail: '',
        IdCelPhone: '',
        IdHomePhone: '',
        IdState: '',
        IdCity: '',
        IdFileDoc: '',
        IdTermiCondi: '',
        IdNewsLetter: '',
        IdObservaciones: 'Actualización Administrativa',
        CodRoles: [],
        CodUserTypes: [],
      },
      formUpdAreaUser: [],
      formUpdAreaModel: {
        idUpdatedBy: this.$session.get('IberoJWTAdminLogin').idPerson,
        IdPerson: '',
        CodAreas: [],
      },
      formUpdate: [
        {
          id: 'IdDocTypeName',
          model: 'IdDocTypeName',
          name: 'Tipo de identificación',
          type: 'informative',
          placeholder: 'Tipo de identificación',
          values: '',
          validate: {
            required: false,
          },
          class: 'col-md-3',
        },
        {
          id: 'IdDocument',
          model: 'IdDocument',
          name: 'Documento de Identidad',
          type: 'informative',
          placeholder: 'Documento de Identidad',
          values: '',
          validate: {
            required: false,
            max: 15,
          },
          class: 'col-md-3',
        },
        {
          id: 'IdBanner',
          model: 'IdBanner',
          name: 'Id Banner',
          type: 'informative',
          placeholder: 'Id Banner',
          values: '',
          validate: {
            required: false,
          },
          class: 'col-md-6',
        },
        {
          id: 'IdNombre',
          model: 'IdNombre',
          name: 'Nombres',
          type: 'informative',
          placeholder: 'Nombres',
          values: '',
          validate: {
            required: true,
          },
          class: 'col-md-6',
        },
        {
          id: 'IdApellidos',
          model: 'IdApellidos',
          name: 'Apellidos',
          type: 'informative',
          placeholder: 'Apellidos',
          values: '',
          validate: {
            required: true,
          },
          class: 'col-md-6',
        },
        {
          id: 'IdAddress',
          model: 'IdAddress',
          name: 'Dirección',
          type: 'informative',
          placeholder: 'Dirección',
          values: this.$store.state.listAddress,
          validate: {
            required: true,
          },
          class: 'col-md-6',
        },
        {
          id: 'IdMail',
          model: 'IdMail',
          name: 'Correo Electrónico Personal',
          type: 'informative',
          placeholder: 'Correo Electrónico Personal',
          values: '',
          validate: {
            required: true,
            email: true,
          },
          class: 'col-md-6',
        },
        {
          id: 'IdCelPhone',
          model: 'IdCelPhone',
          name: 'Teléfono Celular',
          type: 'informative',
          placeholder: 'Teléfono Celular',
          values: '',
          validate: {
            required: true,
            numeric: true,
            max: 10,
          },
          class: 'col-md-3',
        },
        {
          id: 'IdHomePhone',
          model: 'IdHomePhone',
          name: 'Teléfono Fijo',
          type: 'informative',
          placeholder: 'Teléfono Fijo',
          values: '',
          validate: {
            required: false,
            numeric: true,
            max: 7,
          },
          class: 'col-md-3',
        },
        {
          id: 'IdState',
          model: 'IdState',
          name: 'Departamento',
          type: 'Select',
          placeholder: 'Departamento',
          class: 'col-md-3',
          values: this.$store.state.StateList,
          validate: {
            required: true,
          },
        },
        {
          id: 'IdCity',
          model: 'IdCity',
          name: 'Ciudad',
          type: 'Select',
          placeholder: 'Ciudad',
          validate: {
            required: true,
          },
          class: 'col-md-3',
          values: this.$store.state.CityList,
        },
        {
          id: 'IdNewsLetter',
          name: 'Informacion Comercial',
          model: 'IdNewsLetter',
          type: 'accepted',
          placeholder: 'Recibir informacion comercial',
          values: '',
          validate: {
            required: false,
          },
          class: 'col-md-6 linkref',
        },
      ],
      HDPersons: [
        {
          name: 'idBanner',
          title: 'Id Banner',
          width: '10%',
        },
        {
          name: 'nameDocument',
          title: 'Tipo Identificación',
          width: '20%',
        },
        {
          name: 'numDocument',
          title: 'Num Identificación',
          width: '20%',
        },
        {
          name: 'namPerson',
          title: 'Nombres',
          sortField: 'namPerson',
          width: '20%',
        },
        {
          name: 'lastNamePerson',
          title: 'Apellidos',
          sortField: 'lastNamePerson',
          width: '20%',
        },
        {
          name: '__slot:telefono',
          title: 'Celular',
          width: '10%',
        },
        {
          name: '__slot:status',
          title: 'Activo',
          dataClass: 'text-center',
          width: '10%',
        },
        {
          name: '__slot:actions',
          dataClass: 'text-right',
          actionRef: [
            {
              label: 'Editar',
              icon: 'fa-pencil',
              action: 'edit',
            },
          ],
        },
      ],
      HDTransfer: [
        {
          name: 'idPeriod',
          title: 'Programa',
          width: '20%',
        },
        {
          name: 'namOperator',
          title: 'Centro de Transferencia',
          width: '20%',
        },
        {
          name: 'desPeriod',
          title: 'Periodo',
          width: '10%',
        },
        {
          name: '__slot:sello',
          title: 'Sello F.',
          width: '10%',
        },
        {
          name: '__slot:editar',
          title: 'Editar',
          width: '30%',
        },
      ],
      DLPersons: [],
      SelectPerson: [],
      UpdateOperator: [],
      renderComponent1: false,
      renderComponent2: false,
      addRExito: false,
      refNoUpdate: false,
      refWSUpdate: false,
    }
  },
  methods: {
    loadModel (idRole, refList) {
      var itemList = this.formUpdModel.CodRoles.filter(item => {
        if (parseInt(item.idRole) === parseInt(idRole)) {
          return item
        }
      })
      if (refList === 1 && itemList.length === 1) {
        return itemList[0].rolStatus
      } else if (refList === 2 && itemList.length === 1) {
        return true
      } else {
        return false
      }
    },
    loadRoles () {
      this.areatab = false
      this.activetab = 2
      let loader = this.$loading.show()
      var RolData = IberoHelpers.getRolData(this.$store)
      RolData.then(Response => {
        if (Response.data) {
          this.listRol = Response.data
          for (var i = 0; i < Response.data.length; i++) {
            this.modelRol[Response.data[i].idRole] = this.loadModel(
              Response.data[i].idRole,
              1
            )
          }
        } else {
          this.refNoRol = true
        }
        loader.hide()
      })
    },
    loadAreas () {
      this.areatab = true
      this.activetab = 3
      let loader = this.$loading.show()
      var AreaData = IberoHelpers.getAreasUser(
        this.$store,
        this.formUpdModel.IdPerson
      )
      AreaData.then(Response => {
        this.infoArea = false
        if (Response.data) {
          this.listArea = Response.data
          for (var i = 0; i < Response.data.length; i++) {
            if (Response.data[i].Areas !== undefined) {
              for (var j = 0; j < Response.data[i].Areas.length; j++) {
                var statusUser = Response.data[i].Areas[j].AreaStatus === undefined ? false : Response.data[i].Areas[j].AreaStatus
                this.formUpdAreaModel.CodAreas.push({
                  IdArea: Response.data[i].Areas[j].IdArea + '_' + Response.data[i].IdRole,
                  AreaStatus: statusUser,
                })
                this.modelArea[Response.data[i].Areas[j].IdArea + '_' + Response.data[i].IdRole] =
                this.loadModelArea(Response.data[i].Areas[j].IdArea + '_' + Response.data[i].IdRole, 1)
              }
            }
          }
          this.infoArea = true
        } else {
          this.refNoArea = true
        }
        this.formUpdAreaUser = this.formUpdAreaModel.CodAreas
        this.formUpdAreaModel.CodAreas = []
        loader.hide()
      })
    },
    loadModelArea (IdArea, refList) {
      var itemList = this.formUpdAreaModel.CodAreas.filter(item => {
        if (item.IdArea === IdArea) {
          return item
        }
      })
      if (refList === 1 && itemList.length === 1) {
        return itemList[0].AreaStatus
      } else if (refList === 2 && itemList.length === 1) {
        return true
      } else {
        return false
      }
    },
    UpdateUser () {
      this.limpiaref()
      if (this.activetab === 1) {
        return new Promise((resolve, reject) => {
          this.$refs.obsFieldsUpdate.validate().then(results => {
            if (!results) {
              resolve(false)
            } else {
              let loader = this.$loading.show()
              var totalinf = IberoHelpers.sendFormUpdate(
                this.$store,
                this.formUpdModel
              )
              totalinf.then(Response => {
                this.renderComponent1 = false
                if (Response === false) {
                  this.refWSUpdate = true
                  resolve(false)
                } else if (!(Response.status === 200)) {
                  this.refNoUpdate = true
                  resolve(false)
                } else {
                  this.addRExito = true
                  resolve(true)
                }
                this.$modal.hide('UpdateModal')
                this.searchForm()
                loader.hide()
              })
            }
          })
        })
      } else {
        let message = {
          title: 'Actualización - Roles y Permisos',
          body:
            '¿ Se realizará la actualización de estado, roles y permisos al usuario ' +
            this.formUpdModel.IdNombre +
            ' ' +
            this.formUpdModel.IdApellidos +
            ', está seguro de realizar esta actualización ?',
        }
        let options = {
          okText: 'Continuar',
          cancelText: 'Cerrar',
        }
        this.$dialog.confirm(message, options).then(dialog => {
          this.loadUpdateRol()
        })
      }
    },
    loadUpdateRol () {
      let loader = this.$loading.show()
      this.updateRol.length = 0
      this.addRol.length = 0
      for (var i = 0; i < this.formUpdModel.CodRoles.length; i++) {
        this.updateRol.push({
          IdUser: this.formUpdModel.CodRoles[i].idUser,
          StaActive: this.modelRol[this.formUpdModel.CodRoles[i].idRole],
        })
      }
      for (const items in this.modelRol) {
        if (this.modelRol[items] === true) {
          if (!this.loadModel(items, 2)) {
            this.addRol.push({
              IdPerson: this.formUpdModel.IdPerson,
              IdRole: items,
            })
          }
        }
      }
      if (this.addRol.length >= 1) {
        IberoHelpers.updateRoleByPerson(this.$store, this.addRol, 4)
      }

      IberoHelpers.updateStatusPerson(this.$store, this.formUpdModel, 6)

      var resultRol = IberoHelpers.updateRoleByPerson(
        this.$store,
        this.updateRol,
        5
      )
      resultRol.then(Response => {
        this.addRExito = true
        this.$modal.hide('UpdateModal')
        this.searchForm()
        loader.hide()
      })
    },
    UpdateUserArea () {
      this.limpiaref()
      if (this.activetab === 3) {
        let message = {
          title: 'Actualización - Area por Roles',
          body:
            '¿ Se realizará la actualización de las areas por cada rol al usuario ' +
            this.formUpdModel.IdNombre +
            ' ' +
            this.formUpdModel.IdApellidos +
            ', está seguro de realizar esta actualización ?',
        }
        let options = {
          okText: 'Continuar',
          cancelText: 'Cerrar',
        }
        this.$dialog.confirm(message, options).then(dialog => {
          this.loadUpdateArea()
        })
      }
    },
    loadUpdateArea () {
      let loader = this.$loading.show()
      this.updateArea.length = 0
      this.addArea.length = 0
      for (var i = 0; i < this.listArea.length; i++) {
        if (this.listArea[i].Areas !== undefined) {
          for (var j = 0; j < this.listArea[i].Areas.length; j++) {
            this.updateArea.push({
              IdUser: this.listArea[i].IdUser,
              IdArea: this.listArea[i].Areas[j].IdArea,
              StaActive: this.modelArea[this.listArea[i].Areas[j].IdArea + '_' + this.listArea[i].IdRole],
            })
          }
        }
      }
      for (const items in this.modelArea) {
        if (this.modelArea[items] === true) {
          for (var k = 0; k < this.listArea.length; k++) {
            if (this.listArea[k].Areas !== undefined) {
              for (var l = 0; l < this.listArea[k].Areas.length; l++) {
                if (this.listArea[k].Areas[l].IdArea + '_' + this.listArea[k].IdRole === items) {
                  if (this.listArea[k].Areas[l].AreaStatus === undefined) {
                    this.addArea.push({
                      IdUser: this.listArea[k].IdUser,
                      IdArea: items.split('_')[0],
                    })
                  }
                }
              }
            }
          }
        }
      }
      if (this.addArea.length >= 1) {
        IberoHelpers.updateAreaByPerson(this.$store, this.addArea, 4)
      }

      var resultArea = IberoHelpers.updateAreaByPerson(this.$store, this.updateArea, 5)

      resultArea.then(Response => {
        this.addRExito = true
        this.$modal.hide('UpdateModal')
        this.searchForm()
        loader.hide()
      })
    },
    CancelUser () {
      this.limpiaref()
      this.$modal.hide('UpdateModal')
    },
    limpiaref () {
      this.addRExito = false
      this.refNoUpdate = false
      this.refWSUpdate = false
    },
    searchForm () {
      document.getElementById('refNoData').classList.add('noShow')
      let loader = this.$loading.show()
      var ListPersons = IberoHelpers.getPersonList(
        this.$store,
        this.formSchModel,
        0
      )
      this.renderComponent1 = false
      ListPersons.then(Response => {
        if (Response.data === undefined || Response.data === '') {
          document.getElementById('refNoData').classList.remove('noShow')
        } else {
          if (Array.isArray(Response.data)) {
            this.DLPersons = Response.data
          } else {
            this.DLPersons = [Response.data]
          }
          IberoHelpers.forceRerender1(this)
        }
        loader.hide()
      })
    },
    executeProcess: function (event, refer) {
      this.limpiaref()
      switch (event.target.id) {
        case 'EditOperator':
          refer.IdBanner = this.formUpdModel.IdBanner
          refer.actPeriod = event.periodo
          this.UpdateOperator.push(refer)
          break
        case 'IdState':
          this.formUpdModel.IdCity = ''
          IberoHelpers.getCitiesListByState(
            this.$store.state.ApiIbero.WSParametric,
            this.$store.state.CityList,
            event.target.value
          )
          break
        case 'btn_Sch_Button':
          return new Promise((resolve, reject) => {
            this.$refs.obsFieldsSearch.validate().then(results => {
              if (!results) {
                resolve(false)
              } else {
                this.searchForm()
                resolve(true)
              }
            })
          })
        case 'Sch_Document':
          if (event.target.value) {
            this.formSearch[0].validate.required = true
          } else {
            this.formSearch[0].validate.required = false
          }
          break
      }
      this.$refs.obsFieldsSearch.validate()
    },
    processData: function (dataInf, refdata) {
      this.areatab = false
      this.activetab = 1
      this.limpiaref()
      IberoHelpers.getCitiesListByState(
        this.$store.state.ApiIbero.WSParametric,
        this.$store.state.CityList,
        dataInf.codResidenceDepartment
      )
      this.formUpdModel.IdStatus = dataInf.staStatus
      this.formUpdModel.IdUsrName = dataInf.usrName
      this.formUpdModel.IdPerson = dataInf.idPerson
      this.formUpdModel.IdDocType = dataInf.idDocumentType
      this.formUpdModel.IdDocTypeName = IberoHelpers.dataObjFind(
        this.$store.state.DocTypesList,
        dataInf.idDocumentType
      )
      this.formUpdModel.IdDocument = dataInf.numDocument
      this.formUpdModel.IdBanner = dataInf.idBanner
      this.formUpdModel.IdNombre = dataInf.namPerson
      this.formUpdModel.IdApellidos = dataInf.lastNamePerson
      this.formUpdModel.IdAddress = dataInf.resAddress

      this.formUpdModel.IdHomePhone = ''
      this.formUpdModel.IdCelPhone = ''
      this.formUpdModel.IdMail = ''

      if (!(dataInf.information === undefined)) {
        for (var i = 0; i < dataInf.information.length; i++) {
          if (dataInf.information[i].idContactType === 1) {
            this.formUpdModel.IdHomePhone =
              dataInf.information[i].desContactInformation
          } else if (dataInf.information[i].idContactType === 2) {
            this.formUpdModel.IdCelPhone =
              dataInf.information[i].desContactInformation
          } else if (dataInf.information[i].idContactType === 3) {
            this.formUpdModel.IdMail =
              dataInf.information[i].desContactInformation
          }
        }
      }

      this.formUpdModel.IdState = dataInf.codResidenceDepartment
      this.formUpdModel.IdCity = dataInf.codResidenceCity

      this.formUpdModel.IdTermiCondi = dataInf.termsConditions
      this.formUpdModel.IdNewsLetter = dataInf.infReceive
      this.formUpdModel.CodRoles = dataInf.userRoles
      this.formUpdModel.CodUserTypes = dataInf.userType

      IberoHelpers.forceRerender2(this)
      this.$modal.show('UpdateModal')
    },
  },
}
</script>